import { motion } from "framer-motion";
import { Btn, HeroImage, MaskTitle, Reveal } from "./Reveal";

export const MiniFeatures = ({ items, testId }) => (
  <div data-testid={testId} className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-y-6">
    {items.map((f, i) => (
      <div key={f.title} className={`flex gap-3 sm:px-4 first:sm:pl-0 ${i > 0 ? "sm:border-l border-[var(--line)]" : ""}`}>
        <f.icon className="h-8 w-8 shrink-0" strokeWidth={1.4} />
        <div>
          <p className="font-head font-semibold text-[13px] leading-tight">{f.title}</p>
          <p className="mt-1 text-[13px] text-[var(--body)] leading-snug">{f.text}</p>
        </div>
      </div>
    ))}
  </div>
);

export default function PageHero({ eyebrow, lines, text, img, alt, cta, ctaTo, ctaOnClick, features, testId, imgClass = "" }) {
  return (
    <section data-testid={testId} className="grid lg:grid-cols-2 min-h-[560px] border-b border-[var(--line)]">
      <div className="flex flex-col justify-center px-5 sm:px-8 lg:pl-12 lg:pr-10 xl:pl-[max(3rem,calc((100vw-1280px)/2+3rem))] py-14 lg:py-16">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }} className="eyebrow">{eyebrow}</motion.p>
        <MaskTitle testId={`${testId}-title`} lines={lines} className="mt-5 text-[2.5rem] sm:text-6xl xl:text-[4.1rem]" />
        <Reveal delay={0.5}>
          <p className="mt-6 text-[17px] sm:text-lg text-[var(--body)] leading-relaxed max-w-md">{text}</p>
          {cta && <Btn to={ctaTo} onClick={ctaOnClick} testId={`${testId}-cta`} className="mt-8">{cta}</Btn>}
          {features && <MiniFeatures items={features} testId={`${testId}-features`} />}
        </Reveal>
      </div>
      <HeroImage testId={`${testId}-image`} src={img} alt={alt} className={`min-h-[380px] lg:min-h-full ${imgClass}`} />
    </section>
  );
}

export const SplitSection = ({ eyebrow, title, text, img, alt, reverse, testId, children, bg = "bg-white" }) => (
  <section data-testid={testId} className={`grid lg:grid-cols-2 ${bg}`}>
    <Reveal y={0} className={`relative min-h-[320px] lg:min-h-[440px] overflow-hidden ${reverse ? "lg:order-2" : ""}`}>
      <img src={img} alt={alt} className="absolute inset-0 h-full w-full object-cover" />
    </Reveal>
    <div className="flex flex-col justify-center px-5 sm:px-8 lg:px-14 py-14 lg:py-16">
      <Reveal>
        <p className="eyebrow">{eyebrow}</p>
        <h2 data-testid={`${testId}-title`} className="headline mt-4 text-4xl sm:text-5xl">{title}</h2>
        {text && <p className="mt-5 text-[17px] text-[var(--body)] leading-relaxed max-w-lg">{text}</p>}
        {children}
      </Reveal>
    </div>
  </section>
);

export const IconList = ({ items, cols = 1, testId }) => (
  <div data-testid={testId} className={`grid gap-x-8 gap-y-6 ${cols === 2 ? "sm:grid-cols-2" : ""}`}>
    {items.map((f) => (
      <div key={f.title} className="flex gap-4 group">
        <f.icon className="h-8 w-8 shrink-0 transition-transform duration-300 group-hover:scale-110" strokeWidth={1.4} />
        <div>
          <p className="font-head font-semibold text-[15px] leading-tight">{f.title}</p>
          <p className="mt-1 text-[14px] text-[var(--body)] leading-snug">{f.text}</p>
        </div>
      </div>
    ))}
  </div>
);
